import PurchaseorderStockTransferComponent from '../../procurement/purchaseorder/PurchaseorderStockTransferComponent';
import React, {useState, useEffect, useRef} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Form, Field} from 'react-final-form';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {InputText} from "primereact/inputtext";
import {classNames} from "primereact/utils";
import {addLocale} from "primereact/api";
import axios from "axios";
import {InputMask} from "primereact/inputmask";
import moment from "moment/moment";
import {Calendar} from "primereact/calendar";
import {Panel} from "primereact/panel";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {InputNumber} from "primereact/inputnumber";
import {AutoComplete} from "primereact/autocomplete";
import download from "js-file-download";

const InventorydocumentFormComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity, id} = useParams();

  const [loading, setLoading] = useState(false);
  const [loadingMaterials, setLoadingMaterials] = useState(false);
  const [loadingItems, setLoadingItems] = useState(false);
  const [formData, setFormData] = useState({
    date: moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
    items: []
  });
  const [newFormData, setNewFormData] = useState({});
  const emptyDateTimeViewDate = moment().startOf('day').toDate();
  const [warehouses, setWarehouses] = useState([]);
  const [warehouseDisplayValue, setWarehouseDisplayValue] = useState('');
  const [warehouseToDisplayValue, setWarehouseToDisplayValue] = useState('');
  const [warehouseLocations, setWarehouseLocations] = useState([]);
  const [materials, setMaterials] = useState([]);
  const [items, setItems] = useState([]);

  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const dt = useRef(null);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1,
  });

  const [partners, setPartners] = useState([]);
  const [shippingOptions, setShippingOptions] = useState([]);
  const [shippingChoice, setShippingChoice] = useState(undefined);
  const [shippingError, setShippingError] = useState(false);
  const shippingPartnerId = formData.partner?.id || formData.partner;
  useEffect(() => {
    let cancelled = false;
    setShippingChoice(undefined); setShippingOptions([]); setShippingError(false);
    if (props.view !== 'delivery_note' || !shippingPartnerId) return;
    axios.get(`${process.env.REACT_APP_API_HOST}/api/v2/inventory-document/delivery-note/addresses/${shippingPartnerId}`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('userToken')}`, 'App-Network': localStorage.getItem('networkId')}
    }).then(r => { if (!cancelled) setShippingOptions(r.data.data.items); })
      .catch(() => { if (!cancelled) setShippingError(true); });
    return () => { cancelled = true; };
  }, [shippingPartnerId, props.view]);
  const [partnerDisplayValue, setPartnerDisplayValue] = useState('');
  const [company, setCompany] = useState([]);

  const [deliveryNoteFile, setDeliveryNoteFile] = useState(null);
  const [deliveryNoteFileId, setDeliveryNoteFileId] = useState(null);
  const [uploadingFile, setUploadingFile] = useState(false);
  const isExisting = !!(formData.id || window.App.urlVars().inventoryDocumentId);
  const deliveryFileInputRef = useRef(null);
  const hasSavedFile = !!(isExisting && formData.file && !deliveryNoteFileId);

  const [selectedMaterials, setSelectedMaterials] = useState([]);
  const isInventoryDocumentEntity = entity === 'inventory-document' || entity === 'transfer-supplier' ||
    props.entity === 'inventory-document' || props.entity === 'transfer-supplier';
  const inventoryDocumentBaseUrl = props.backlink || '/inventory/inventory-document';

  const view = window.App.urlVars().view || 'transfer_supplier';

  const usesWarehouseStock =
    view === 'pick_list' ||
    view === 'relocation' ||
    view === 'transfer_2st' ||
    view === 'scrap_note' ||
    view === 'return_to_supplier' ||
    view === 'delivery_note';

  const apiEntity =
    view === 'pick_list' ? 'pick-list' :
      view === 'relocation' ? 'relocation' :
        view === 'transfer_2st' ? 'transfer-2st' :
          view === 'scrap_note' ? 'scrap-note' :
            view === 'inventory_count' ? 'inventory-count' :
              view === 'return_by_customer' ? 'return-by-customer' :
                view === 'return_to_supplier' ? 'return-to-supplier' :
                  view === 'delivery_note' ? 'delivery-note' :
                    'transfer-supplier';

  const locationField =
    view === 'transfer_supplier' || view === 'transfer_2st' || view === 'return_by_customer'
      ? 'warehouse_location_to'
      : 'warehouse_location_from';

  const locationWarehouseId = locationField === 'warehouse_location_from'
    ? (formData.warehouse_from?.id ?? formData.warehouse_from)
    : (formData.warehouse_to?.id ?? formData.warehouse_to);

  const selectedWarehouseFrom = warehouses.find((w) => w.id === (formData.warehouse_from?.id ?? formData.warehouse_from)) || null;
  const selectedWarehouseTo = warehouses.find((w) => w.id === (formData.warehouse_to?.id ?? formData.warehouse_to)) || null;
  const selectedLocationWarehouse = locationField === 'warehouse_location_from' ? selectedWarehouseFrom : selectedWarehouseTo;

  const showWarehouseLocationColumn = view === 'relocation'
    ? true
    : !!selectedLocationWarehouse?.warehouse_location_required;

  let loadLazyTimeout = useRef(null);
  const loadLazyData = () => {
    setLoadingMaterials(true);

    if (loadLazyTimeout.current) {
      clearTimeout(loadLazyTimeout.current);
    }

    loadLazyTimeout.current = setTimeout(() => {
      let query = window.App.transformQueryParams(lazyParams);

      if (usesWarehouseStock) {
        const warehouseFromId = formData.warehouse_from?.id || formData.warehouse_from;

        if (!warehouseFromId) {
          setMaterials([]);
          setTotalRecords(0);
          setLoadingMaterials(false);
          return;
        }

        const separator = query ? '&' : '?';
        const inventoryQuery = `${query}${separator}search[warehouse][operator]==&search[warehouse][value]=${warehouseFromId}`;

        apiCall('GET', '/api/v2/inventory' + inventoryQuery)
          .then(response => {
            setTotalRecords(response.data.data.total_item_count);
            setMaterials(response.data.data.items);
          })
          .catch(error => {
            window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          })
          .finally(() => {
            setLoadingMaterials(false);
          });
        return;
      }

      if (isInventoryDocumentEntity) {
        apiCall('GET', '/api/v2/material' + query)
          .then(response => {
            setTotalRecords(response.data.data.total_item_count);
            setMaterials(response.data.data.items);
          })
          .catch(error => {
            window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          })
          .finally(() => {
            setLoadingMaterials(false);
          });
      }

      if (entity === 'purchase-order') {
        apiCall('GET', '/api/v2/purchase-order-item' + query + '&search[purchase_order][operator]=%3D&search[purchase_order][value]=' + id)
          .then(response => {
            setTotalRecords(response.data.data.total_item_count);
            setMaterials(response.data.data.items);
          })
          .catch(error => {
            window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          })
          .finally(() => {
            setLoadingMaterials(false);
          });
      }
    }, Math.random() * 1000 + 250);
  };

  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  };

  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  };

  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  };

  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
          {options.first} - {options.last} / {options.totalRecords}
        </span>
      );
    }
  };

  const uploadDeliveryNoteFile = async (file) => {
    if (!file) return;
    setUploadingFile(true);
    try {
      const fd = new FormData();
      fd.append('file', file);
      const res = await apiCall('post', '/api/v2/file/upload', fd);
      const fileId = res?.data?.data?.id;
      setDeliveryNoteFileId(fileId);
      setFormData((prev) => ({...prev, file: fileId}));
      setNewFormData((prev) => ({...prev, file: fileId}));
      window.App.toastShow('success', t('toastFileUploaded'));
    } catch (err) {
      window.App.toastShow('error', t('error'), err.toString(), '', err.response);
    } finally {
      setUploadingFile(false);
    }
  };

  const downloadDeliveryNoteFile = async () => {
    const fileId = formData?.file?.id ?? formData.file ?? deliveryNoteFileId;
    setUploadingFile(true);
    try {
      const res = await axios.get(
        process.env.REACT_APP_API_HOST + '/api/v2/file/' + fileId + '/download',
        {
          responseType: 'blob',
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('userToken'),
            'App-Network': localStorage.getItem('networkId'),
          },
        }
      );
      const filename = formData?.file?.filename || deliveryNoteFile?.name;
      download(res.data, filename);
    } catch (err) {
      window.App.toastShow('error', t('error'), err.toString(), '', err.response);
    } finally {
      setUploadingFile(false);
    }
  };

  const [totalRecordsItems, setTotalRecordsItems] = useState(0);
  const [rowsItems, setRowsItems] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const dtItems = useRef(null);
  const [lazyParamsItems, setLazyParamsItems] = useState({
    first: 0,
    rows: rowsItems,
    page: 0,
    sortField: 'id',
    sortOrder: -1,
    filters: {
      purchase_order_request: {value: id, matchMode: 'equals'}
    }
  });

  let loadLazyTimeoutItems = useRef(null);
  const loadLazyDataItems = () => {
    if (isInventoryDocumentEntity) return;

    setLoadingItems(true);

    if (loadLazyTimeoutItems.current) {
      clearTimeout(loadLazyTimeoutItems.current);
    }

    loadLazyTimeoutItems.current = setTimeout(() => {
      let query = window.App.transformQueryParams(lazyParamsItems);

      apiCall('GET', '/api/v2/purchase-order-request-item' + query)
        .then(response => {
          setTotalRecordsItems(response.data.data.total_item_count);
          setItems(response.data.data.items);
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoadingItems(false);
        });
    }, Math.random() * 1000 + 250);
  };

  const onPageItems = (event) => {
    let _lazyParams = {...lazyParamsItems, ...event};
    setLazyParamsItems(_lazyParams);
  };

  const onSortItems = (event) => {
    let _lazyParams = {...lazyParamsItems, ...event};
    setLazyParamsItems(_lazyParams);
  };

  const onFilterItems = (event) => {
    let _lazyParams = {...lazyParamsItems, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParamsItems(_lazyParams);
  };

  const pagerItems = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRowsItems(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
          {options.first} - {options.last} / {options.totalRecords}
        </span>
      );
    }
  };

  const draggableCell = (rowData, content) => {
    const material = rowData?.material || rowData;
    const matId = material?.id || rowData.id;
    const isAdded = formData.id
      ? items.some(it => it.material === matId || it.material?.id === matId)
      : formData.items.some(it => it.material === matId);
    return (
      <div
        draggable={!isAdded && (!formData.status || formData.status === 'DRAFT')}
        className={'added-' + isAdded}
        style={{cursor: isAdded ? 'not-allowed' : 'move'}}
        onDragStart={(e) => {
          if (isAdded) return;
          handleDragStart(e, rowData);
        }}
      >
        {content}
      </div>
    );
  };

  const updateInventoryItemField = (rowId, fieldName, value) => {
    const el = document.getElementById(`${fieldName}_${rowId}`);
    const target = el?.querySelector('input') || el?.querySelector('.p-dropdown-label') || el;

    if (target) {
      target.style.setProperty('background-color', '#ffc107', 'important');
      target.style.setProperty('color', 'white', 'important');
    }

    if (!window.inventoryItemTimeout) window.inventoryItemTimeout = {};
    if (window.inventoryItemTimeout[rowId]) clearTimeout(window.inventoryItemTimeout[rowId]);

    window.inventoryItemTimeout[rowId] = setTimeout(() => {
      apiCall('patch', `/api/v2/inventory-document-item/${apiEntity}/${rowId}`, {
        [fieldName]: value
      })
        .then(() => {
          if (target) {
            target.style.setProperty('background-color', '#28a745', 'important');
            target.style.setProperty('color', 'white', 'important');
          }
        })
        .catch(error => {
          if (target) {
            target.style.setProperty('background-color', 'red', 'important');
            target.style.setProperty('color', 'white', 'important');
          }
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        });
    }, 400);
  };

  const validate = () => {
    let errors = {};

    return errors;
  };

  const onSubmit = () => {
    setLoading(true);

    const warehouseFromId = formData.warehouse_from?.id || formData.warehouse_from;
    const warehouseToId = formData.warehouse_to?.id || formData.warehouse_to;
    const partnerId = formData.partner?.id || formData.partner;
    const companyId = formData.company?.id || formData.company;
    const fileId = deliveryNoteFileId ?? formData.file;

    const payload = {
      date: moment(formData.date).format('YYYY-MM-DD HH:mm:ss'),
      description: formData.description,
    };

    if (
      (
        view === 'pick_list' ||
        view === 'relocation' ||
        view === 'transfer_2st' ||
        view === 'scrap_note' ||
        view === 'inventory_count' ||
        view === 'return_to_supplier' ||
        view === 'delivery_note'
      ) && warehouseFromId
    ) {
      payload.warehouse_from = warehouseFromId;
    }

    if (
      (
        view === 'transfer_supplier' ||
        view === 'transfer_2st' ||
        view === 'return_by_customer'
      ) && warehouseToId
    ) {
      payload.warehouse_to = warehouseToId;
    }

    if (
      (
        view === 'transfer_supplier' ||
        view === 'return_by_customer' ||
        view === 'transfer_2st' ||
        view === 'delivery_note'
      ) && companyId
    ) payload.company = companyId;
    if ((view === 'transfer_supplier' || view === 'return_to_supplier' || view === 'delivery_note') && partnerId) payload.partner = partnerId;
    if (view === 'delivery_note' && shippingChoice !== undefined) payload.shipping_address_id = shippingChoice || null;
    if (view === 'transfer_supplier' && formData.document_number) payload.document_number = formData.document_number;
    if (view === 'transfer_supplier' && fileId) payload.file = fileId;

    if (formData.id) {
      apiCall('patch','/api/v2/inventory-document/' + apiEntity + '/' + (window.App.urlVars().inventoryDocumentId ?? formData.id ?? id),payload)
        .then(response => {
          window.App.toastShow('success', t('toastSaveSuccess'));
          window.App.setState({rerenderInventorydocumentList: Math.random()});
          setFormData(response.data.data);
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      apiCall('post', '/api/v2/inventory-document/' + apiEntity, payload)
        .then(response => {
          window.App.toastShow('success', t('toastSaveSuccess'));
          window.App.setState({rerenderInventorydocumentList: Math.random()});

          if (props.goback === true) {
            const backUrl = inventoryDocumentBaseUrl;
            history.push(view ? `${backUrl}?view=${view}` : (props.backlink || backUrl));
            setFormData(response.data.data);

            if (response.data.data.id) {
              refreshItems(response.data.data.id);
            }
          } else {
            const baseUrl = `${inventoryDocumentBaseUrl}/update/${response.data.data.id}`;
            history.push(view ? `${baseUrl}?view=${view}` : baseUrl);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  const safeDecodeURIComponent = (value) => {
    if (!value) return '';
    let decoded = value;
    try {
      decoded = decodeURIComponent(decoded);
    } catch (e) {}
    try {
      decoded = decodeURIComponent(decoded);
    } catch (e) {}
    return decoded;
  };

  const searchWarehouse = (event) => {
    const q = (event?.query || '').trim();
    if (q.length < 2) {
      setWarehouses([]);
      return;
    }
    setLoading(true);
    axios
      .get(
        process.env.REACT_APP_API_HOST +
        '/api/v2/warehouse?rows=15'
        +
        '&search[name][operator]=like' +
        '&search[name][value]=' + encodeURIComponent('%' + q + '%'),
        {
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('userToken'),
            'App-Network': localStorage.getItem('networkId'),
          },
        }
      )
      .then((response) => {
        const list = response?.data?.data?.items ?? [];
        const mapped = list.map((p) => ({
          ...p,
          name:
            p.name +
            (p.addressPostalCode || p.addressCity || p.addressDetail
              ? ` (${p.addressPostalCode ?? ''} ${p.addressCity ?? ''}, ${p.addressDetail ?? ''})`
              : ''),
        }));
        setWarehouses(mapped);
      })
      .catch((error) => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
      .finally(() => setLoading(false));
  };

  const searchPartner = (event) => {
    const q = (event?.query || '').trim();

    if (q.length < 2) {
      setPartners([]);
      return;
    }

    setLoading(true);

    axios
      .get(
        process.env.REACT_APP_API_HOST +
        '/api/v2/partner?rows=15' +
        '&search[name][operator]=like' +
        '&search[name][value]=' + encodeURIComponent('%' + q + '%'),
        {
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('userToken'),
            'App-Network': localStorage.getItem('networkId'),
          },
        }
      )
      .then((response) => {
        const list = response?.data?.data?.items ?? [];
        const mapped = list.map((p) => ({
          ...p,
          name:
            p.name +
            (p.addressPostalCode || p.addressCity || p.addressDetail
              ? ` (${p.addressPostalCode ?? ''} ${p.addressCity ?? ''}, ${p.addressDetail ?? ''})`
              : ''),
        }));
        setPartners(mapped);
      })
      .catch((error) => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
      .finally(() => setLoading(false));
  };

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('userToken'),
        'App-Network': localStorage.getItem('networkId')
      }
    });
  };

  const handleDragStart = (event, rowData) => {
    const mapDraggedItem = (item) => {
      const material = item?.material || item;

      return {
        ...item,
        id: material?.id || item?.id,
        material,
        warehouse_location: item?.warehouse_location || null,
      };
    };

    let itemsToDrag = [mapDraggedItem(rowData)];

    if (selectedMaterials.some(sel => sel.id === rowData.id)) {
      itemsToDrag = selectedMaterials.map(mapDraggedItem);
    }

    event.dataTransfer.setData('application/json', JSON.stringify(itemsToDrag));
  };

  const handleDrop = async (event, target) => {
    event.preventDefault();

    if (target !== 'right') return;

    let droppedItems = [];

    try {
      const jsonData = event.dataTransfer.getData('application/json');
      if (jsonData) {
        droppedItems = JSON.parse(jsonData);
      } else {
        const textData = event.dataTransfer.getData('text/plain');
        droppedItems = [JSON.parse(textData)];
      }
    } catch (e) {
      console.error('Hiba a droppolt adatok feldolgozásakor', e);
      return;
    }

    const docId = window.App.urlVars().inventoryDocumentId ?? formData.id ?? id;

    if (isInventoryDocumentEntity) {
      if (!docId) {
        window.App.toastShow('warn', t('warning'), t('saveDocumentFirst'));
        return;
      }

      const newItemsToAdd = droppedItems.filter(droppedItem =>
        !items.some(item => item.material === droppedItem.id || item.material?.id === droppedItem.id)
      );

      if (newItemsToAdd.length === 0) {
        window.App.toastShow('info', t('information'), t('selectedItemsAlreadyAdded'));
        return;
      }

      setLoadingItems(true);

      try {
        await Promise.all(newItemsToAdd.map(item =>
          apiCall('post', '/api/v2/inventory-document-item/' + apiEntity, {
            inventory_document: docId,
            material: item.id,
            ...(item?.warehouse_location?.id || item?.warehouse_location
              ? {warehouse_location_from: item.warehouse_location.id || item.warehouse_location}
              : {})
          })
        ));

        window.App.toastShow('success', t('itemsAdded', {count: newItemsToAdd.length}));
        setSelectedMaterials([]);
        refreshItems(docId);
      } catch (error) {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      } finally {
        setLoadingItems(false);
      }
    }

    if (target === 'right' && !formData.id) {
      const currentItemIds = formData.items.map(it => it.material);
      const filteredNewItems = droppedItems.filter(it => !currentItemIds.includes(it.id));

      if (filteredNewItems.length > 0) {
        const newFormattedItems = filteredNewItems.map(it => ({
          material: it.id,
          quantity: 1,
          [locationField]: null
        }));

        setFormData({
          ...formData,
          items: [...formData.items, ...newFormattedItems]
        });
        setSelectedMaterials([]);
      }
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const refreshItems = (docId) => {
    if (!docId) return;

    setLoadingItems(true);

    apiCall(
      'get',
      `/api/v2/inventory-document-item?search[inventory_document][operator]==&search[inventory_document][value]=${docId}`
    )
      .then((response) => {
        const list = response?.data?.data?.items ?? [];
        const total = response?.data?.data?.total_item_count ?? list.length;

        setItems(list);
        setTotalRecordsItems(total);

        if (lazyParamsItems.first >= total && total > 0) {
          setLazyParamsItems((prev) => ({
            ...prev,
            first: Math.max(0, Math.floor((total - 1) / prev.rows) * prev.rows),
            page: Math.max(0, Math.floor((total - 1) / prev.rows)),
          }));
        }

        if (total === 0) {
          setLazyParamsItems((prev) => ({
            ...prev,
            first: 0,
            page: 0,
          }));
        }
      })
      .catch((error) => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
      .finally(() => setLoadingItems(false));
  };

  useEffect(() => {
    loadLazyData();
  }, [lazyParams, formData.warehouse_from, view]);

  useEffect(() => {
    loadLazyDataItems();
  }, [lazyParamsItems]);

  useEffect(() => {
    if (!locationWarehouseId) {
      setWarehouseLocations([]);
      return;
    }

    if (view !== 'relocation' && !selectedLocationWarehouse?.warehouse_location_required) {
      setWarehouseLocations([]);
      return;
    }

    let locationUrl = `/api/v2/warehouse-location?search[warehouse][operator]==&search[warehouse][value]=${locationWarehouseId}`;

    if (view === 'transfer_supplier' || view === 'pick_list') {
      locationUrl += '&search[type][operator]==&search[type][value]=PICK';
    }

    if (view === 'scrap_note') {
      locationUrl += '&search[type][operator]==&search[type][value]=QUARANTINE';
    }

    apiCall('get', locationUrl)
      .then((response) => setWarehouseLocations(response.data.data.items))
      .catch((error) =>
        window.App.toastShow('error', t('error'), error.toString(), '', error.response)
      );
  }, [formData.warehouse_from, formData.warehouse_to, warehouses, view]);

  useEffect(() => {
    apiCall('GET', '/api/v2/company')
      .then((response) => {
        const items = response?.data?.data?.items ?? [];
        setCompany(items);

        if (items.length === 1) {
          setFormData((prev) => (prev.company ? prev : {...prev, company: items[0].id}));
          setNewFormData((prev) => (prev.company ? prev : {...prev, company: items[0].id}));
        }
      })
      .catch((error) => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      });
  }, []);

  useEffect(() => {
    apiCall('GET', '/api/v2/warehouse')
      .then(response => {
        setWarehouses(response.data.data.items);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      });

    if (id && !window.App.urlVars().create) {
      setLoading(true);

      apiCall('get', '/api/v2/inventory-document/' + (window.App.urlVars().inventoryDocumentId ?? id))
        .then(response => {
          setFormData(response.data.data);

          if (isInventoryDocumentEntity && response.data.data.id) {
            refreshItems(response.data.data.id);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [id, entity]);

  useEffect(() => {
    const urlVars = window.App.urlVars();

    if (urlVars.partnerName) {
      const decodedName = decodeURIComponent(urlVars.partnerName);
      setPartnerDisplayValue(decodedName);
      setFormData((prev) => ({
        ...prev,
        partner: Number(urlVars.partnerId) || null,
      }));
      setNewFormData((prev) => ({
        ...prev,
        partner: Number(urlVars.partnerId) || null,
      }));
    }
  }, [window.App.urlVars().partnerName]);

  useEffect(() => {
    const urlVars = window.App.urlVars();
    if (urlVars.warehouseName && urlVars.warehouseId) {
      const decodedName = safeDecodeURIComponent(urlVars.warehouseName);
      const warehouseId = Number(urlVars.warehouseId) || null;
      const target = urlVars.warehouseTarget || 'from';
      if (target === 'to') {
        setWarehouseToDisplayValue(decodedName);
        setFormData((prev) => ({
          ...prev,
          warehouse_to: warehouseId,
        }));
        setNewFormData((prev) => ({
          ...prev,
          warehouse_to: warehouseId,
        }));
      } else {
        setWarehouseDisplayValue(decodedName);
        setFormData((prev) => ({
          ...prev,
          warehouse_from: warehouseId,
        }));
        setNewFormData((prev) => ({
          ...prev,
          warehouse_from: warehouseId,
        }));
      }
    }
  }, [window.App.urlVars().warehouseName, window.App.urlVars().warehouseTarget]);

  useEffect(() => {
    if (!warehouseDisplayValue && formData?.warehouse_from && typeof formData.warehouse_from === 'object') {
      setWarehouseDisplayValue(formData.warehouse_from.name);
    }
  }, [formData.warehouse_from, formData.warehouse_to, warehouseDisplayValue]);

  useEffect(() => {
    if (formData?.partner && typeof formData.partner === 'object') {
      setPartnerDisplayValue(formData.partner.name || '');
    }
    if (!formData?.partner) {
      setPartnerDisplayValue('');
    }
  }, [formData.partner]);

  useEffect(() => {
    const warehouseFromId = formData.warehouse_from?.id ?? formData.warehouse_from;
    if (!warehouseFromId) {
      setWarehouseDisplayValue('');
      return;
    }
    const warehouseFromName =
      formData.warehouse_from?.name ||
      warehouses.find((w) => Number(w.id) === Number(warehouseFromId))?.name ||
      warehouseDisplayValue;
    setWarehouseDisplayValue(warehouseFromName || '');
  }, [formData.warehouse_from, warehouses]);

  useEffect(() => {
    const warehouseToId = formData.warehouse_to?.id ?? formData.warehouse_to;
    if (!warehouseToId) {
      setWarehouseToDisplayValue('');
      return;
    }
    const warehouseToName =
      formData.warehouse_to?.name ||
      warehouses.find((w) => Number(w.id) === Number(warehouseToId))?.name ||
      warehouseToDisplayValue;
    setWarehouseToDisplayValue(warehouseToName || '');
  }, [formData.warehouse_to, warehouses]);

  if (formData.procurement_stock_transfer && formData.id) {
    return <PurchaseorderStockTransferComponent documentId={formData.id}
      onDeleted={() => history.push(inventoryDocumentBaseUrl)}/>;
  }


  return (
    <div className={'inventorydocument-form widget'}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: 'absolute', top: 0, left: 0, borderRadius: 0}}></ProgressBar>
      }

      <Form onSubmit={onSubmit} initialValues={formData}
            validate={validate} render={({handleSubmit}) => (
        <form onSubmit={handleSubmit} className="">
          <div className={'p-grid'}>
            <div className={'p-col-12 p-lg-4'}>
              <Field name="date" render={({input, meta}) => (
                <span className="p-field p-fluid">
                  <label htmlFor="date"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldDate')}</label>
                  <div className="p-inputgroup calendar-icon-only">
                    <InputMask
                      id={'date'}
                      disabled={formData.status && formData.status === 'COMPLETED'}
                      mask={'9999-99-99 99:99'}
                      placeholder={t('dateTimePlaceholder')}
                      value={formData.date ? moment(formData.date).format('YYYY-MM-DD HH:mm') : ''}
                      onChange={(e) => {
                        if (e.value.indexOf('_') === -1) {
                          if (e.value === '') {
                            setFormData({
                              ...formData,
                              date: null
                            });
                            setNewFormData({
                              ...newFormData,
                              date: null
                            });
                            return;
                          }
                          const selectedDate = moment(e.value, 'YYYY-MM-DD HH:mm', true);
                          if (!selectedDate.isValid()) {
                            return;
                          }
                          setFormData({
                            ...formData,
                            date: selectedDate.format('YYYY-MM-DD HH:mm:ss')
                          });
                          setNewFormData({
                            ...newFormData,
                            date: selectedDate.format('YYYY-MM-DD HH:mm:ss')
                          });
                        }
                      }}
                    />
                    <Calendar
                              value={formData.date ? moment(formData.date, 'YYYY-MM-DD HH:mm:ss').toDate() : null}
                              viewDate={!formData.date ? emptyDateTimeViewDate : null}
                              locale="hu"
                              dateFormat={'yy-mm-dd'}
                              showIcon
                              showTime
                              hourFormat="24"
                              stepMinute={1}
                              disabled={formData.status && formData.status === 'COMPLETED'}
                              onChange={(e) => {
                                const selectedDate = (!formData.date && e.value ? moment(e.value).startOf('day') : moment(e.value)).format('YYYY-MM-DD HH:mm:ss');
                                setFormData({
                                  ...formData,
                                  date: selectedDate
                                });
                                setNewFormData({
                                  ...newFormData,
                                  date: selectedDate
                                });
                              }}
                            />
                  </div>
                  {getFormErrorMessage(meta)}
                </span>
              )}/>
            </div>

            {(
              view === 'pick_list' ||
              view === 'relocation' ||
              view === 'transfer_2st' ||
              view === 'scrap_note' ||
              view === 'inventory_count' ||
              view === 'return_to_supplier' ||
              view === 'delivery_note'
            ) &&
              <div className={'p-col-12 p-lg-4'}>
                <Field name="warehouse_from" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="warehouse_from"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>
                      {view === 'transfer_2st' ? t('fieldStartingWarehouse') : view === 'return_to_supplier' ? t('fieldCurrentWarehouse') : t('fieldWarehouse')}
                    </label>
                    <span className="p-inputgroup">
                      <Button type="button" className={"p-button"}
                              onClick={() => {
                                const urlVars = window.App.urlVars();
                                const params = new URLSearchParams();
                                Object.entries(urlVars).forEach(([key, value]) => {
                                  if (value !== undefined && value !== null && value !== '') {
                                    params.set(key, value);
                                  }
                                });
                                const currentPath = window.location.hash
                                  .replace('#', '')
                                  .split('?')[0];
                                const currentFullPath = window.location.hash.replace('#', '');
                                params.set('backlink', currentFullPath);
                                params.set('search', 'warehouse');
                                params.set('warehouseTarget', 'from');
                                history.push(`${currentPath}?${params.toString()}`);
                              }}>
                        <i className={"pi pi-search"}></i>
                      </Button>
                      <AutoComplete
                        id="warehouse_from"
                        value={warehouseDisplayValue}
                        suggestions={
                          view === 'relocation'
                            ? warehouses.filter((w) => w.warehouse_location_required)
                            : warehouses
                        }
                        completeMethod={searchWarehouse}
                        field="name"
                        delay={700}
                        forceSelection
                        placeholder={t('warehouseSearchPlaceholder')}
                        // disabled={formData.id}
                        disabled={formData.status && formData.status === 'COMPLETED'}
                        emptyMessage={t('noWarehouseYet')}
                        className={classNames({'p-error': isFormFieldValid(meta)})}
                        onSelect={(e) => {
                          setWarehouseDisplayValue(e.value.name);
                          setFormData({
                            ...formData,
                            warehouse_from: e.value.id
                          });
                          setNewFormData({
                            ...newFormData,
                            warehouse_from: e.value.id
                          });
                        }}
                        onChange={(e) => {
                          setWarehouseDisplayValue(e.value);
                          if (typeof e.value === 'string') {
                            setFormData({
                              ...formData,
                              warehouse_from: null
                            });
                            setNewFormData({
                              ...newFormData,
                              warehouse_from: null
                            });
                          }
                        }}
                        onClear={() => {
                          setWarehouseDisplayValue('');
                          setFormData({
                            ...formData,
                            warehouse_from: null
                          });
                          setNewFormData({
                            ...newFormData,
                            warehouse_from: null
                          });
                        }}
                      />
                    </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
            }

            {(
              view === 'transfer_supplier' ||
              view === 'transfer_2st' ||
              view === 'return_by_customer'
            ) &&
              <div className={'p-col-12 p-lg-4'}>
                <Field name="warehouse_to" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="warehouse_to"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>
                      {view === 'transfer_2st' ? t('fieldArrivalWarehouse') : t('fieldWarehouse')}
                    </label>
                    <span className="p-inputgroup">
                      <Button
                        type="button"
                        className="p-button"
                        // disabled={formData.id}
                        disabled={formData.status && formData.status === 'COMPLETED'}
                        onClick={() => {
                          const urlVars = window.App.urlVars();
                          const params = new URLSearchParams();
                          Object.entries(urlVars).forEach(([key, value]) => {
                            if (value !== undefined && value !== null && value !== '') {
                              params.set(key, value);
                            }
                          });
                          const currentPath = window.location.hash
                            .replace('#', '')
                            .split('?')[0];
                          const currentFullPath = window.location.hash.replace('#', '');
                          params.set('backlink', currentFullPath);
                          params.set('search', 'warehouse');
                          params.set('warehouseTarget', 'to');
                          history.push(`${currentPath}?${params.toString()}`);
                        }}
                      >
                        <i className="pi pi-search"></i>
                      </Button>

                      <AutoComplete
                        id="warehouse_to"
                        value={warehouseToDisplayValue}
                        suggestions={warehouses}
                        completeMethod={searchWarehouse}
                        field="name"
                        delay={700}
                        forceSelection
                        placeholder={t('warehouseSearchPlaceholder')}
                        // disabled={formData.id}
                        disabled={formData.status && formData.status === 'COMPLETED'}
                        emptyMessage={t('noWarehouseYet')}
                        className={classNames({'p-error': isFormFieldValid(meta)})}
                        onSelect={(e) => {
                          const selectedWarehouse = e.value;
                          setWarehouseToDisplayValue(selectedWarehouse?.name || '');
                          setFormData((prev) => ({
                            ...prev,
                            warehouse_to: selectedWarehouse?.id || null
                          }));
                          setNewFormData((prev) => ({
                            ...prev,
                            warehouse_to: selectedWarehouse?.id || null
                          }));
                        }}
                        onChange={(e) => {
                          const value = e.value;
                          if (typeof value === 'string') {
                            setWarehouseToDisplayValue(value);
                            return;
                          }
                          if (value && typeof value === 'object') {
                            setWarehouseToDisplayValue(value.name || '');
                            setFormData((prev) => ({
                              ...prev,
                              warehouse_to: value.id || null
                            }));
                            setNewFormData((prev) => ({
                              ...prev,
                              warehouse_to: value.id || null
                            }));
                          }
                        }}
                        onClear={() => {
                          setWarehouseToDisplayValue('');
                          setFormData((prev) => ({
                            ...prev,
                            warehouse_to: null
                          }));
                          setNewFormData((prev) => ({
                            ...prev,
                            warehouse_to: null
                          }));
                        }}
                      />
                    </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
            }

            {(view === 'transfer_supplier' || view === 'return_to_supplier' || view === 'delivery_note') &&
              <div className="p-col-12 p-lg-4">
                <Field
                  name="partner"
                  render={({meta}) => (
                    <div className="p-field p-fluid">
                      <label
                        htmlFor="partner"
                        className={classNames({'p-error': isFormFieldValid(meta)})}
                      >
                        {props.view === 'delivery_note' ? props.t('fieldPartner') : props.t('fieldSupplier')}
                      </label>

                      <span className="p-inputgroup">
                        <Button
                          type="button"
                          className="p-button"
                          onClick={() => {
                            const urlVars = window.App.urlVars();
                            const params = new URLSearchParams();

                            Object.entries(urlVars).forEach(([key, value]) => {
                              if (value !== undefined && value !== null && value !== '') {
                                params.set(key, value);
                              }
                            });

                            params.set('search', 'partner');

                            const currentPath = window.location.hash
                              .replace('#', '')
                              .split('?')[0];

                            history.push(`${currentPath}?${params.toString()}`);
                          }}
                          // disabled={formData.id || (formData.status && formData.status !== 'DRAFT')}
                          disabled={formData.status && formData.status === 'COMPLETED'}
                        >
                          <i className="pi pi-search"></i>
                        </Button>

                        <AutoComplete
                          id="partner"
                          value={partnerDisplayValue}
                          suggestions={partners}
                          completeMethod={searchPartner}
                          field="name"
                          delay={700}
                          forceSelection
                          placeholder={t('typeToSearchPlaceholderEllipsis')}
                          className={classNames({'p-invalid': isFormFieldValid(meta)})}
                          onSelect={(e) => {
                            setPartnerDisplayValue(e.value.name);
                            setFormData({...formData, partner: e.value.id});
                            setNewFormData({...newFormData, partner: e.value.id});
                          }}
                          onChange={(e) => {
                            setPartnerDisplayValue(e.value);
                            setFormData({...formData, partner: null});
                            setNewFormData({...newFormData, partner: null});
                          }}
                          onClear={() => {
                            setPartnerDisplayValue('');
                            setFormData({...formData, partner: null});
                            setNewFormData({...newFormData, partner: null});
                          }}
                          // disabled={formData.id || (formData.status && formData.status !== 'DRAFT')}
                          disabled={formData.status && formData.status === 'COMPLETED'}
                        />
                      </span>

                      {getFormErrorMessage(meta)}
                    </div>
                  )}
                />
              </div>
            }

            {view === 'delivery_note' && <div className="p-col-12 p-lg-4"><div className="p-field p-fluid">
              <label htmlFor="delivery-shipping-address">{t('fieldDeliveryAddress')}</label>
              <Dropdown id="delivery-shipping-address" options={shippingOptions.map(a => ({...a, label: `${a.id === 0 ? t('deliveryAddressMain') : t(`deliveryAddressTypes.${a.type}`, {defaultValue: a.type || ''})} — ${a.label || '—'}`}))}
                optionLabel="label" optionValue="id" value={shippingChoice ?? (formData.shipping_address_snapshot?.partner_id === Number(shippingPartnerId) ? formData.shipping_address_snapshot?.source_id ?? 0 : 0)}
                disabled={!shippingPartnerId || formData.status === 'COMPLETED'} onChange={e => setShippingChoice(e.value)}/>
              {shippingError && <small className="p-error">{t('deliveryAddressLoadFailed')}</small>}
              {shippingChoice === undefined && formData.shipping_address_snapshot?.partner_id === Number(shippingPartnerId) && <small>{t('deliveryAddressSaved')}: {[formData.shipping_address_snapshot.country_code, formData.shipping_address_snapshot.postal_code, formData.shipping_address_snapshot.city, formData.shipping_address_snapshot.detail].filter(Boolean).join(' ')}</small>}
            </div></div>}
            {(view === 'transfer_supplier' || view === 'return_by_customer' || view === 'transfer_2st' || view === 'delivery_note') &&
              <div className={'p-col-12 p-lg-4'}>
                <Field name="company" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="company" className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldCompany')}</label>
                    <span className="p-d-block">
                      <Dropdown
                        id="company"
                        options={window.App.sortDropdownOptions(company, "name")}
                        optionValue="id"
                        optionLabel="name"
                        value={formData.company?.id || formData.company || null}
                        emptyMessage={t('noCompanyYet')}
                        onChange={(e) => {
                          setFormData({...formData, company: e.value});
                          setNewFormData({...newFormData, company: e.value});
                        }}
                      />
                    </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
            }

            <div className={'p-col-12 p-lg-4'}>
              <Field name="description" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="description"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldNote')}</label>
                  <span className="p-d-block">
                    <InputText id="description" {...input}
                              //  disabled={formData.id}
                              disabled={formData.status && formData.status === 'COMPLETED'}
                               onChange={(e) => {
                                 setFormData({
                                   ...formData,
                                   description: e.target.value
                                 });
                                 setNewFormData({
                                   ...newFormData,
                                   description: e.target.value
                                 });
                               }}
                               value={formData.description}
                               className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                  </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>

            {isInventoryDocumentEntity && view === 'transfer_supplier' &&
              <div className={'p-col-12 p-lg-4'}>
                <Field name="document_number" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="document_number"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldDocumentNumber')}</label>
                    <span className="p-d-block">
                      <InputText id="document_number" {...input}
                                //  disabled={formData.id}
                                disabled={formData.status && formData.status === 'COMPLETED'}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     document_number: e.target.value
                                   });
                                   setNewFormData({
                                     ...newFormData,
                                     document_number: e.target.value
                                   });
                                 }}
                                 value={formData.document_number}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
            }

            {isInventoryDocumentEntity && view === 'transfer_supplier' &&
              <div className="p-col-12 p-lg-8">
                <div className="p-field">
                  <label>
                    {hasSavedFile ? t('deliveryNoteDownload') : t('deliveryNoteUpload')}
                  </label>
                  <div>
                    <input
                      type="file"
                      ref={deliveryFileInputRef}
                      style={{display: 'none'}}
                      onChange={(e) => {
                        const f = e.target.files?.[0];
                        if (f) {
                          setDeliveryNoteFile(f);
                          uploadDeliveryNoteFile(f);
                        }
                        e.target.value = null;
                      }}
                      // disabled={
                      //   uploadingFile ||
                      //   (formData.status && formData.status !== 'DRAFT')
                      // }
                    />
                    {!hasSavedFile && (
                      <Button
                        type="button"
                        className="p-button p-ml-2"
                        onClick={() => {
                          if (
                            !uploadingFile &&
                            (!formData.status || formData.status === 'DRAFT')
                          ) {
                            deliveryFileInputRef.current?.click();
                          }
                        }}
                        disabled={
                          uploadingFile ||
                          (formData.status && formData.status !== 'DRAFT')
                        }
                      >
                        <i className="pi pi-plus"/>
                        &nbsp;
                        {uploadingFile
                          ? t('uploading')
                          : (deliveryNoteFile?.name || t('chooseFile'))}
                      </Button>
                    )}
                    {hasSavedFile && (
                      <Button
                        type="button"
                        icon="pi pi-download"
                        className="p-button-secondary"
                        onClick={downloadDeliveryNoteFile}
                        disabled={uploadingFile}
                        tooltip={t('deliveryNoteDownload')}
                        tooltipOptions={{position: 'left'}}
                      />
                    )}
                  </div>
                </div>
              </div>
            }
          </div>

          <div className={'p-grid p-mt-1'}>
            <div className={'p-col-12 p-lg-6 p-xl-6'}>

            </div>
            <div className={'p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center'}>
              {formData.id && (
                <Button type="button" label={t('finish')}
                        loading={loading}
                        icon={'pi pi-check'}
                        disabled={formData.status === 'COMPLETED' || items.length === 0}
                        className="p-button-warning p-ml-2"
                        onClick={() => {
                          setLoading(true);
                          apiCall('post', '/api/v2/inventory-document/' + apiEntity + '/' + (window.App.urlVars().inventoryDocumentId ?? formData.id ?? id) + '/complete',
                            {}
                          )
                            .then(response => {
                              window.App.toastShow('success', t('toastFinishSuccess'));
                              window.App.setState({rerenderInventorydocumentList: Math.random()});
                              setFormData(response.data.data);
                            })
                            .catch(error => {
                              window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                            })
                            .finally(() => {
                              setLoading(false);
                            });
                        }}/>
              )}
                <>
                  {isInventoryDocumentEntity &&
                    <Button type="submit" label={t('save')}
                            loading={loading}
                            // disabled={formData.id}
                            disabled={formData.status && formData.status === 'COMPLETED'}
                            icon={'pi pi-save'}
                            className="p-button-success p-ml-2"/>
                  }
                  <Button type="submit" label={t('saveAndBack')}
                          onClick={() => {
                            props = {...props, goback: true};
                          }}
                          // disabled={formData.id}
                          disabled={formData.status && formData.status === 'COMPLETED'}
                          loading={loading}
                          icon={'pi pi-arrow-left'}
                          className="p-button-success p-ml-2"/>
                </>
            </div>
          </div>

          {formData.id && (
            <div className={'p-grid p-mt-3'}>
              <div className={'p-col-12 p-lg-6'}
                   onDragOver={handleDragOver}
                   onDrop={(e) => handleDrop(e, 'left')}
              >
                <Panel>
                  <h4 className={'p-mt-0'}>
                    {usesWarehouseStock ? t('warehouseStock') : t('products')}
                  </h4>

                  {isInventoryDocumentEntity &&
                    <DataTable
                      emptyMessage={t('noResults')}
                      size={'small'}
                      value={materials} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
                      onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                      onFilter={onFilter} filters={lazyParams.filters} lazy
                      paginatorTemplate={pager} rows={rows}
                      autoLayout={true}
                      filterDisplay="row"
                      responsiveLayout="scroll"
                      stripedRows
                      ref={dt}
                      selection={selectedMaterials}
                      onSelectionChange={(e) => setSelectedMaterials(e.value)}
                      dataKey="id"
                      loading={loadingMaterials}
                    >
                      <Column selectionMode="multiple" headerStyle={{width: '3em'}}></Column>
                      <Column
                              field="name"
                              filterField={usesWarehouseStock ? 'material_name' : 'name'}
                              sortField={usesWarehouseStock ? 'material_name' : 'name'}
                              header={t('columnName')}
                              sortable
                              filter
                              body={(rowData) => {
                                const name = rowData?.material?.name || rowData.name;
                                return draggableCell(rowData, name);
                              }}
                      ></Column>
                      <Column
                              field="upc"
                              filterField={usesWarehouseStock ? 'material_upc' : 'upc'}
                              sortField={usesWarehouseStock ? 'material_upc' : 'upc'}
                              header={t('upc')}
                              sortable
                              filter
                              body={(rowData) => {
                                return draggableCell(rowData, rowData?.material?.upc || rowData?.upc || '');
                              }}
                      ></Column>
                      {usesWarehouseStock &&
                        <Column field="warehouse_location" header={t('columnWarehouseLocation')}
                                body={(rowData) => {
                                  return draggableCell(rowData, rowData?.warehouse_location?.code || '');
                                }}
                        ></Column>
                      }
                      {usesWarehouseStock &&
                        <Column field="quantity" header={t('columnCurrentStock')}
                                body={(rowData) => {
                                  return draggableCell(rowData, rowData?.quantity ?? '');
                                }}
                        ></Column>
                      }
                    </DataTable>
                  }

                  {entity === 'purchase-order' &&
                    <DataTable
                      emptyMessage={t('noResults')}
                      size={'small'}
                      value={materials} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
                      onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                      onFilter={onFilter} filters={lazyParams.filters} lazy
                      paginatorTemplate={pager} rows={rows}
                      autoLayout={true}
                      filterDisplay="row"
                      responsiveLayout="scroll"
                      stripedRows
                      ref={dt}
                      dataKey="id"
                      loading={loadingMaterials}
                    >
                      <Column field="name" header={t('columnName')} sortable filter
                              body={(rowData) => {
                                return (
                                  <div draggable
                                       className={'added-' + (formData.items.some(item => item.material === rowData.id) || Boolean(formData?.id))}
                                       style={{cursor: 'move'}}
                                       onDragStart={(e) => handleDragStart(e, rowData)}
                                  >
                                    {rowData?.material?.name}
                                  </div>
                                );
                              }}
                      ></Column>
                    </DataTable>
                  }
                </Panel>
              </div>

              <div className={'p-col-12 p-lg-6'}
                   onDragOver={handleDragOver}
                   onDrop={(e) => handleDrop(e, 'right')}
              >
                <Panel>
                  <h4 className={'p-mt-0'}>
                    {view === 'pick_list' ? t('pickedProducts') :
                      view === 'relocation' ? t('movedProducts') :
                        view === 'transfer_2st' ? t('transferredProducts') :
                          view === 'scrap_note' ? t('scrappedProducts') :
                            view === 'inventory_count' ? t('inventoriedProducts') :
                              view === 'return_by_customer' ? t('returnedProducts') :
                                view === 'return_to_supplier' ? t('sentBackProducts') :
                                  view === 'delivery_note' ? t('deliveryNoteItems') :
                                    t('receivedProducts')}
                  </h4>

                  <DataTable
                    emptyMessage={t('noResults')}
                    size={'small'}
                    value={isInventoryDocumentEntity && formData.id ? items : formData.items}
                    paginator first={lazyParamsItems.first} totalRecords={totalRecordsItems}
                    onPage={onPageItems}
                    onSort={onSortItems} sortField={lazyParamsItems.sortField} sortOrder={lazyParamsItems.sortOrder}
                    onFilter={onFilterItems} filters={lazyParamsItems.filters} lazy
                    paginatorTemplate={pagerItems} rows={rowsItems}
                    autoLayout={true}
                    filterDisplay="row"
                    responsiveLayout="scroll"
                    stripedRows
                    ref={dtItems}
                    dataKey="id"
                    loading={loadingItems}
                  >
                    <Column header={t('columnName')} sortable filter
                            body={(rowData) => {
                              if (formData.id) {
                                return (
                                  <>
                                    {rowData?.material?.name}
                                  </>
                                );
                              } else {
                                let material = materials.find(item => item.id === rowData.material);
                                return (
                                  <>
                                    {material?.name || material?.material?.name}
                                  </>
                                );
                              }
                            }}
                    ></Column>

                    <Column header={t('upc')} sortable filter
                            body={(rowData) => {
                              if (formData.id) {
                                return rowData?.material?.upc;
                              }

                              const selectedMaterial = materials.find(item => item.id === rowData.material);
                              return selectedMaterial?.upc || selectedMaterial?.material?.upc || '';
                            }}
                    ></Column>

                    <Column field="quantity" header={t('columnQuantity')} sortable filter
                            body={(rowData) => {
                              if (isInventoryDocumentEntity && formData.id) {
                                return (
                                  <InputNumber
                                    id={'quantity_' + rowData.id}
                                    inputProps={{id: 'quantity_' + rowData.id}}
                                    minFractionDigits={0}
                                    maxFractionDigits={9}
                                    locale="hu-HU"
                                    value={rowData.quantity}
                                    disabled={formData.status === 'COMPLETED'}
                                    className="p-inputtext-sm"
                                    onValueChange={(e) => {
                                      const newQty = e.value;

                                      setItems((prev) =>
                                        prev.map((item) =>
                                          item.id === rowData.id ? {...item, quantity: newQty} : item
                                        )
                                      );

                                      updateInventoryItemField(rowData.id, 'quantity', newQty);
                                    }}
                                  />
                                );
                              }

                              if (formData.id) {
                                return (
                                  <>
                                    {Number(rowData?.quantity)} {rowData?.unit?.name}
                                  </>
                                );
                              } else {
                                return (
                                  <InputNumber minFractionDigits={0}
                                               maxFractionDigits={9}
                                               locale="hu-HU"
                                               onValueChange={(e) => {
                                                 const updatedItems = formData.items.map(item => {
                                                   if (item.material === rowData.material) {
                                                     return {
                                                       ...item,
                                                       quantity: e.value
                                                     };
                                                   }
                                                   return item;
                                                 });

                                                 setFormData({
                                                   ...formData,
                                                   items: updatedItems
                                                 });
                                               }}
                                               value={rowData.quantity}
                                               disabled={formData.id}
                                               className={'p-inputtext-sm'}
                                  />
                                );
                              }
                            }}></Column>

                    {showWarehouseLocationColumn &&
                      <Column
                        header={t('columnWarehouseLocation')}
                        body={(rowData) => {
                          if (isInventoryDocumentEntity && formData.id) {
                            return (
                              <Dropdown
                                id={`${locationField}_${rowData.id}`}
                                showClear
                                value={rowData?.[locationField]?.id || rowData?.[locationField] || null}
                                options={window.App.sortDropdownOptions(warehouseLocations, "code")}
                                optionLabel="code"
                                optionValue="id"
                                disabled={!locationWarehouseId || formData.status === 'COMPLETED'}
                                emptyMessage={t('noLocationYet')}
                                className={'p-inputtext-sm'}
                                onChange={(e) => {
                                  const newLocId = e.value;

                                  setItems((prev) =>
                                    prev.map((it) =>
                                      it.id === rowData.id
                                        ? {
                                          ...it,
                                          [locationField]:
                                            typeof it[locationField] === 'object'
                                              ? {...it[locationField], id: newLocId}
                                              : newLocId,
                                        }
                                        : it
                                    )
                                  );

                                  updateInventoryItemField(rowData.id, locationField, newLocId);
                                }}
                              />
                            );
                          }

                          if (formData.id) {
                            return (
                              <>
                                {rowData?.[locationField]?.code}
                              </>
                            );
                          } else {
                            return (
                              <Dropdown showClear
                                        onChange={(e) => {
                                          const updatedItems = formData.items.map(item => {
                                            if (item.material === rowData.material) {
                                              return {
                                                ...item,
                                                [locationField]: e.value
                                              };
                                            }
                                            return item;
                                          });

                                          setFormData({
                                            ...formData,
                                            items: updatedItems
                                          });
                                        }}
                                        value={rowData?.[locationField]}
                                        options={window.App.sortDropdownOptions(warehouseLocations, "code")}
                                        optionLabel="code"
                                        optionValue="id"
                                        disabled={!locationWarehouseId || formData.id}
                                        emptyMessage={t('noLocationYet')}
                                        className={'p-inputtext-sm'}
                              />
                            );
                          }
                        }}></Column>
                    }

                    <Column body={(rowData) => {
                      return (
                        <React.Fragment>
                          {localStorage.getItem('roles').toString().includes('role_') &&
                            <Button icon="pi pi-trash" className="p-button-danger p-button-sm"
                                    tooltip={t('delete')} tooltipOptions={{position: 'left'}}
                                    type="button"
                                    disabled={formData.status === 'COMPLETED'}
                                    onClick={() => {
                                      if (formData.id) {
                                        setLoading(true);

                                        apiCall('delete', '/api/v2/inventory-document-item/' + rowData.id)
                                          .then(response => {
                                            window.App.toastShow('success', t('toastDeleteSuccess'));
                                            const docId = window.App.urlVars().inventoryDocumentId ?? formData.id ?? id;

                                            apiCall('get', '/api/v2/inventory-document/' + (window.App.urlVars().inventoryDocumentId ?? id))
                                              .then(response => {
                                                setFormData(response.data.data);
                                              })
                                              .catch(error => {
                                                window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                                              })
                                              .finally(() => {
                                                setLoading(false);
                                              });

                                            if (isInventoryDocumentEntity && docId) {
                                              refreshItems(docId);
                                            }
                                          })
                                          .catch(error => {
                                            window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                                          });
                                      } else {
                                        const updatedItems = formData.items.filter(item => item.material !== rowData.material);

                                        setFormData({
                                          ...formData,
                                          items: updatedItems
                                        });
                                      }
                                    }}
                            />
                          }
                        </React.Fragment>
                      );
                    }} className={'p-py-0 p-text-right p-text-nowrap'}></Column>
                  </DataTable>
                </Panel>
              </div>
            </div>
          )}
        </form>
      )}/>
    </div>
  );
};

export default withTranslation('common')(InventorydocumentFormComponent);
